import { ref } from 'vue';
import { Permissions } from '@/constants/permissions';
import { usePermissions } from '@/composable/usePermissions';
import { useOrganizationStore } from '@/store/organizationStore';
import AssetService from '@/services/AssetService';

/**
 * Org-wide anomaly breakdown (Findings badge + summary card).
 * One best-effort aggregate call — shared by the desktop SideNav and the
 * mobile tab bar so both show the same pending count from a single source.
 */
export function useAnomalyBreakdown() {
  const { can } = usePermissions();
  const organizationStore = useOrganizationStore();

  const breakdown = ref({ total: 0, pending: 0, accepted: 0, rejected: 0 });
  const loading = ref(true);

  async function load() {
    if (!can(Permissions.AnomalyView)) {
      loading.value = false;
      return;
    }
    try {
      const assets = await AssetService.getAssetsByOrganizationIdAsync(organizationStore.organizationId);
      const ids = (assets ?? [])
        .filter(a => a.isActive === true || a.isactive === true)
        .map(a => a.id);
      if (!ids.length) return;
      const result = await AssetService.getOrganizationAnomalyBreakdownAsync(ids);
      breakdown.value = result || { total: 0, pending: 0, accepted: 0, rejected: 0 };
    } catch {
      breakdown.value = { total: 0, pending: 0, accepted: 0, rejected: 0 };
    } finally {
      loading.value = false;
    }
  }

  return { breakdown, loading, load };
}
